import { render, staticRenderFns } from "./AboutBio.vue?vue&type=template&id=0173c001&scoped=true&"
import script from "./AboutBio.vue?vue&type=script&lang=ts&"
export * from "./AboutBio.vue?vue&type=script&lang=ts&"
import style0 from "./AboutBio.vue?vue&type=style&index=0&id=0173c001&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0173c001",
  null
  
)

export default component.exports